import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { CartControlExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { getExtensionRules } from '../../../shared/all-extension-rules';

export const SubscriptionSelectorType = CartControlExtension.SubscriptionSelectorType;
export type SubscriptionSelectorType = CartControlExtension.SubscriptionSelectorType;

export const TRANSPARENT_APPEARANCE = 'transparent';

export const RestrictionRules = getExtensionRules({
  excludeRules: [
    RuleEntity.BARCODE,
    RuleEntity.VENDOR,
    RuleEntity.COLLECTION,
    RuleEntity.WEIGHT,
    RuleEntity.HAS_DISCOUNT,
    RuleEntity.CART_ATTRIBUTE_KEY,
    RuleEntity.CART_ATTRIBUTE_VALUE,
    RuleEntity.CART_ATTRIBUTE,
  ],
});

// PDQ-7681 — rule-based exception builder uses PRODUCT/ITEM-level entities only (no customer/cart/
// destination conditions), plus the two item-source entities. Each exception is evaluated PER cart
// line on the server, so only per-line product attributes make sense here.
export const CartControlExceptionRules = getExtensionRules({
  onlyRules: [
    RuleEntity.BARCODE,
    RuleEntity.COLLECTION,
    RuleEntity.ITEM_COUNT,
    RuleEntity.PRODUCT_METAFIELD,
    RuleEntity.PRODUCT_TAG,
    RuleEntity.PRODUCT_TYPE,
    RuleEntity.PROPERTIES_KEY,
    RuleEntity.PROPERTIES_VALUE,
    RuleEntity.SELLING_PLAN,
    RuleEntity.SKU,
    RuleEntity.VARIANT_METAFIELD,
    RuleEntity.VENDOR,
    RuleEntity.ITEM_SOURCE,
    RuleEntity.ITEM_SOURCE_USAGE_TOKEN,
  ],
});
